import { Component } from '@angular/core';
import { AccountService } from '../../../../services/account.service';
import { Observable, Subscription } from 'rxjs';
import {
  IGroup,
  ITimeTable,
  ITimeRange,
  ITimeZone,
} from '../../../../interfaces/graph-types';
import { WatchAccountService } from '../../../../services/watch-account.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ModalCreateGroupComponent } from '../../../modals/create-group/modal-create-group.component';
import { UtilityService } from '../../../../services/utility.service';

@Component({
  selector: '[account-timetables]',
  template: require('./account-timetables.component.pug'),
  styles: [require('./account-timetables.component.css').toString()],
})
export class AccountTimeTablesComponent {
  groups$: Observable<IGroup[]>;
  bsModalRef: BsModalRef;
  subReason: Subscription = null;
  timetables$: Observable<ITimeTable[]>;
  selectedTimeTable: ITimeTable;
  timeRanges: boolean[][];
  timeZoneSub: Subscription;
  timeZones: ITimeZone[];

  //img_empty = require('./empty.png');

  // -------------------------------------------------------------------
  constructor(
    private modalService: BsModalService,
    private accountService: AccountService,
    private watchAccount: WatchAccountService,
    private utilityService: UtilityService,
  ) {
    this.timeZones = [];
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.timetables$ = this.accountService.timetables(
      this.watchAccount.accountId().getValue(),
    );
    this.timeZoneSub = this.utilityService.getTimeZones().subscribe(res => {
      this.timeZones = res.timeZones;
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.timeZoneSub) {
      this.timeZoneSub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  backgroundImg() {
    // return 'url(' + this.img_empty + ')';
  }

  // -------------------------------------------------------------------
  selectTimeTable(timetable) {
    this.selectedTimeTable = timetable;
    this.resetTimeRanges(timetable);
  }

  // -------------------------------------------------------------------
  createTimeTable() {
    this.resetTimeRanges(null);
    this.selectedTimeTable = {
      id: null,
      name: null,
      timeZone: 'UTC',
      workingDays: [false, true, true, true, true, true, false],
    };
  }

  // -------------------------------------------------------------------
  resetTimeRanges(timetable: ITimeTable) {
    this.timeRanges = [];
    for (let i: number = 0; i < 7; i++) {
      this.timeRanges[i] = [];
    }

    if (!timetable) {
      return;
    }

    timetable.timeRanges.forEach((range: ITimeRange) => {
      let from_index = range.fromMinute / 15;
      let to_index = range.toMinute / 15;

      for (let i: number = from_index; i < to_index; i++) {
        this.timeRanges[range.wday][i] = true;
      }
    });
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.selectedTimeTable = null;
  }

  // -------------------------------------------------------------------
  createTimeRange() {
    var items: string[] = [];
    items.push('12am');
    items.push('1am');
    items.push('2am');
    items.push('3am');
    items.push('4am');
    items.push('5am');
    items.push('6am');
    items.push('7am');
    items.push('8am');
    items.push('9am');
    items.push('10am');
    items.push('11am');
    items.push('12pm');
    items.push('1pm');
    items.push('2pm');
    items.push('3pm');
    items.push('4pm');
    items.push('5pm');
    items.push('6pm');
    items.push('7pm');
    items.push('8pm');
    items.push('9pm');
    items.push('10pm');
    items.push('11pm');
    return items;
  }

  // -------------------------------------------------------------------
  isSelected(day, index) {
    return this.timeRanges[day][index];
  }

  mouseMode: boolean = null;

  // -------------------------------------------------------------------
  mouseDown(day, index) {
    this.mouseMode = !this.timeRanges[day][index];
    this.timeRanges[day][index] = this.mouseMode;
    return false;
  }

  // -------------------------------------------------------------------
  mouseUp() {
    this.mouseMode = null;
  }

  // -------------------------------------------------------------------
  mouseEnter(day, index) {
    if (this.mouseMode == null) {
      return;
    }
    this.timeRanges[day][index] = this.mouseMode;
  }

  // -------------------------------------------------------------------
  saveButtomTitle() {
    if (this.selectedTimeTable.id) {
      return 'Save changes';
    }
    return 'Create new time table';
  }

  // -------------------------------------------------------------------
  createRange(number) {
    let items: number[] = [];
    for (let i = 0; i < number; i++) {
      items.push(i);
    }
    return items;
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    let account_id = this.watchAccount.accountId().getValue();

    let timeRanges = [];

    let timeOn = null;
    for (let wday = 0; wday < 7; wday++) {
      timeOn = null;
      for (let index = 0; index < 4 * 24; index++) {
        if (timeOn == null && this.timeRanges[wday][index]) {
          timeOn = index;
        } else {
          if (timeOn != null && !this.timeRanges[wday][index]) {
            let item = {
              wday: wday,
              fromMinute: timeOn * 15,
              toMinute: index * 15,
            };
            timeRanges.push(item);
            timeOn = null;
          }
        }
      }
      if (timeOn != null) {
        let item = {
          wday: wday,
          fromMinute: timeOn * 15,
          toMinute: 24 * 4 * 15,
        };
        timeRanges.push(item);
        timeOn = null;
      }
    }

    this.accountService.createOrUpdateTimeTable(
      account_id,
      this.selectedTimeTable.id,
      this.selectedTimeTable.name,
      this.selectedTimeTable.timeZone,
      timeRanges,
      this.selectedTimeTable.workingDays,
      res => {
        this.selectedTimeTable = null;
        this.timetables$ = this.accountService.timetables(
          this.watchAccount.accountId().getValue(),
        );
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  toggleBusinessDay(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.selectedTimeTable.workingDays[data] = !this.selectedTimeTable
      .workingDays[data];
    onsuccess();
  }
}
